import { ImportOutlined } from '@ant-design/icons';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Button } from 'antd';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { type IMapGroup } from '../../layers/MapGroup.ts';
import { type IMapLayer } from '../../layers/MapLayer.ts';
import { LayerCatalogImportModal } from './LayerCatalogImportModal.tsx';
import { useLayerCatalogImport } from './utils/useLayerCatalogImport.ts';

const StyledImportButton = styled(Button)`
  margin-top: 8px;
`;

export interface ILayerCatalogImportButtonProps {
  groupEditor: RelationEditor<IMapGroup>;
  layersEditor: RelationEditor<IMapLayer>;
}

export function LayerCatalogImportButton(
  props: ILayerCatalogImportButtonProps,
) {
  const { groupEditor, layersEditor } = props;
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  const handleConfirm = useLayerCatalogImport({
    groupEditor,
    layersEditor,
    onImport: close,
  });

  return (
    <>
      <StyledImportButton
        type="dashed"
        block
        size="large"
        icon={<ImportOutlined aria-hidden="true" />}
        onClick={() => setOpen(true)}
      >
        Importa da Catalogo
      </StyledImportButton>
      <LayerCatalogImportModal
        open={open}
        onConfirm={handleConfirm}
        onClose={close}
      />
    </>
  );
}
